import {
  Button,
  Divider,
  IconButton,
  Table,
  TableCell,
  TableRow,
} from "@mui/material";
import { assetsUrl } from "../../../constants";
import { useContext, useEffect, useRef } from "react";
import { EmrContext } from "../..";
import moment from "moment";
import { PatientDetailsType } from "../../types";
import { ReactSketchCanvas, ReactSketchCanvasRef } from "react-sketch-canvas";
import CloseIcon from "@mui/icons-material/Close";
import { useForm } from "react-hook-form";
import { CustomFormField } from "../../../utilis/component/CustomFormElement";
import dayjs from "dayjs";
import { ExtraDataType } from "./types";

const desc = "pt-2 py-1 px-1 mx-7 text-xs text-gray-500";
const desc2 = "pt-2 py-1 px-1 mx-7 text-sm text-gray-800";
const field = "border-b border-[#a86c34]";
const PatientConsentForm = () => {
  const canvasRef = useRef<ReactSketchCanvasRef>(null);
  // const canvasRef2 = useRef<ReactSketchCanvasRef>(null);
  const iframeRef = useRef<HTMLIFrameElement | null>(null);
  const { patientData } = useContext(EmrContext);
  const { handleSubmit, control,reset } = useForm();
  const handlePrintForm = async (value: any) => {
    console.log(value);
    const printData = getPdfString(patientData, value);
    if (iframeRef?.current) {
      iframeRef.current?.contentDocument?.open();
      iframeRef.current?.contentDocument?.write(printData);
      iframeRef.current?.contentDocument?.close();
      const image = iframeRef.current?.contentDocument?.createElement(
        "img"
      ) as HTMLImageElement;
      const sign = iframeRef.current?.contentDocument?.createElement(
        "img"
      ) as HTMLImageElement;
      // const sign2 = iframeRef.current?.contentDocument?.createElement(
      //   "img"
      // ) as HTMLImageElement;
      const signElem = iframeRef.current?.contentDocument?.getElementById(
        "signContainer"
      ) as HTMLImageElement;
      // const signElem2 = iframeRef.current?.contentDocument?.getElementById(
      //   "signContainer2"
      // ) as HTMLImageElement;
      sign.src = await (canvasRef?.current
        ? canvasRef?.current.exportImage("png")
        : "");
      // sign2.src = await (canvasRef?.current
      //   ? canvasRef2?.current.exportImage("png")
      //   : "");
      signElem.appendChild(sign);
      // signElem2.appendChild(sign2);
      const elementInIframe =
        iframeRef.current?.contentDocument?.getElementById(
          "logoContainer"
        ) as HTMLImageElement;
      image.src = `${assetsUrl}/app/consentForms/icon.png`;
      image.alt = "image display here";
      image.onload = (_: Event) => {
        elementInIframe.appendChild(image);
        iframeRef.current?.contentWindow?.print();
      };
    }
  };

  const handleClear = () => {
    if (canvasRef?.current) {
      canvasRef?.current?.clearCanvas();
    }
  };
  // const handleClear2 = () => {
  //   if (canvasRef2?.current) {
  //     canvasRef2?.current?.clearCanvas();
  //   }
  // };

  useEffect(()=>{
    reset({
      date1:dayjs()
    })
  },[])

  return (
    <div>
      <div className="hidden">
        <iframe ref={iframeRef} />
      </div>
      <form onSubmit={handleSubmit(handlePrintForm)}>
        <div className="flex flex-row justify-end px-10">
          <Button type="submit" color="success">
            Download form
          </Button>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            gap: "5px",
          }}
        >
          <div>
            <div className="d-flex gap-2 align-items-center">
              {/* <mat-spinner [diameter]="25" *ngIf="isSpin"></mat-spinner> */}
              {/* <button *ngIf="loggedUser!='doctor'" className="mat-raised-button mat-success" (click)="createConsentForm()">Consent form</button> */}
            </div>
          </div>
          <div>
            <div className="border mx-9 p-2">
              <header>
                <div className="px-3">
                  <img
                    className="h-[50px] w-[140px]"
                    src={`${assetsUrl}/app/consentForms/icon.png`}
                  />
                </div>
              </header>
              <section className="my-[1.5rem] px-3">
                <div className="flex justify-center border-t-2 px-5 py-2 border-[#a86c34]">
                  <h3
                    style={{
                      color: "white",
                      backgroundColor: "#a86c34",
                      width: "fit-content",
                      padding: "2px",
                    }}
                  >
                    Patient Acknowledgement Form
                  </h3>
                </div>
                <p className="py-2 px-2 mx-8 font-semibold text-gray-600 border-[#a86c34] border-t border-b text-sm">
                  Use this form to receive acknowledgement from the Patient for
                  use of their Electronic Healthcare Records with Participating
                  Healthcare Organization and Providers in the RIAYATI HIE.
                </p>
                <p className={desc}>
                  <strong className="text-gray-600">
                    National Unified Medical Record (NUMR) - RIAYATI
                  </strong>
                  is the Health Information Exchange platform of the Ministry of
                  Health and Prevention (MOHAP), UAE. RIAYATI is MOHAP’s
                  centralised repository that enables access to your health
                  information to all the healthcare facilities (such as a
                  hospital, nursing home, polyclinic, clinic, daycare centre,
                  diagnostic centre, etc.) in the UAE that are connected to
                  RIAYATI.
                </p>
                <p className={desc} style={{ marginTop: "12px" }}>
                  While providing access to your health information to a
                  healthcare facility, RIAYATI ensures that security and privacy
                  standards are followed as stipulated in the ICT Law of UAE
                  (“the use of information and communication technology in the
                  healthcare fields” law 2/2019).
                </p>
                <div style={{ paddingTop: "8px" }}>
                  <strong className={"px-8 text-gray-600"}>Benefits</strong>
                </div>
                <p className={desc}>
                  This eliminates need for redundant services, enhances patient
                  safety, provides better access to health services and seamless
                  movement between facilities. It helps the healthcare
                  facilities to provide you more efficient care, help clinicians
                  in accessing clinical records in Emergency situations.
                </p>
                <p className={desc} style={{ marginTop: "12px" }}>
                  Please be informed that your health information would be
                  stored in the National Unified Medical Record – RIAYATI and it
                  will be accessible by the healthcare facilities within UAE.
                </p>
                <div className="px-8">
                  <Divider className="bg-[#a86c34]" />
                </div>
                <p
                  className={desc}
                  style={{ display: "font-weight: bold; font-size: 0.9rem" }}
                >
                  To be completed by the patient:
                </p>
                <p
                  className={desc}
                  style={{
                    display:
                      "font-weight: bold; font-size: 0.9rem; margin-top: 10px",
                  }}
                >
                  PLEASE COMPLETE THE INFORMATION BELOW AND SIGN THIS FORM TO
                  ACKNOWLEDGE THAT YOU HAVE READ AND UNDERSTOOD THE INFORMATION
                  PROVIDED HERE.
                </p>
                <p className={desc} style={{ marginTop: "10px" }}>
                  I understand that my Health Information will be shared with
                  participating healthcare organizations in the RIAYATI.
                </p>
                <p className="text-right text-xs mx-8 p-1">
                  (Please complete this in BLOCK letters)
                </p>
                <div className="w-fit h-fit border mx-8">
                  <Table
                    sx={{ minWidth: "67vw" }}
                    size="small"
                    className="details"
                  >
                    <TableRow>
                      <TableCell>Patient’s Name:</TableCell>
                      {/* <!-- 1 --> */}
                      <TableCell>Last*:</TableCell>
                      {/* <!-- 2 --> */}
                      <TableCell>
                        <div className={`${field} font-[0.85rem]`}>
                          {" "}
                          {patientData?.pmaster?.lastName || ""}
                        </div>
                      </TableCell>
                      {/* <!-- 3 --> */}
                      <TableCell>First*:</TableCell>
                      {/* <!-- 4 --> */}
                      <TableCell>
                        <div className={`${field} font-[0.85rem]`}>
                          {patientData?.pmaster?.firstName || ""}
                        </div>
                      </TableCell>
                      {/* <!-- 5 --> */}
                      <TableCell>Middle:</TableCell>
                      {/* <!-- 6 --> */}
                      <TableCell>
                        <div className={field}>
                          {patientData?.pmaster?.middleName || ""}
                        </div>
                      </TableCell>
                      {/* <!-- 7 --> */}
                    </TableRow>
                    <TableRow>
                      <TableCell>National ID Number*:</TableCell>
                      <TableCell colSpan={2}>
                        <div className={`${field} font-[0.85rem]`}>
                          {patientData?.pmaster?.emiratesId || ""}
                        </div>
                      </TableCell>
                      <TableCell>Patient’s DOB*:</TableCell>
                      <TableCell>
                        <div className={`${field} font-[0.85rem]`}>
                          {patientData?.pmaster?.dob || ""}
                        </div>
                      </TableCell>
                      <TableCell>Sex (M/F)</TableCell>
                      <TableCell>
                        <div className={`${field} font-[0.85rem]`}>
                          {patientData?.pmaster?.gender || ""}
                        </div>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Primary Phone#*:</TableCell>
                      <TableCell colSpan={2}>
                        <div className={`${field} font-[0.85rem]`}>
                          {patientData?.amaster?.mobileNo || ""}
                        </div>
                      </TableCell>
                      <TableCell>Secondary Phone#:</TableCell>
                      <TableCell>
                        <div className={`${field} font-[0.85rem]`}>
                          {patientData?.amaster?.mobileNo || ""}
                        </div>
                      </TableCell>
                      <TableCell>Email</TableCell>
                      <TableCell>
                        <div className={field}>
                          {patientData?.amaster?.email || ""}
                        </div>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Postal Address *:</TableCell>
                      <TableCell colSpan={6}>
                        <div className={`${field} font-[0.85rem]`}>
                          {patientData?.amaster?.address1 || ""}
                        </div>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>City *:</TableCell>
                      <TableCell colSpan={3}>
                        <div className={`${field} font-[0.85rem]`}>
                          {patientData?.amaster?.place || ""}
                        </div>
                      </TableCell>
                      <TableCell>PO Box *:</TableCell>
                      <TableCell colSpan={2}>
                        <div className={`${field} font-[0.85rem]`}></div>
                      </TableCell>
                    </TableRow>
                  </Table>
                </div>
                <p className="text-right text-xs mx-8 p-1">
                  * mandatory information
                </p>

                <div className="grid grid-cols-2 items-end px-7 py-2">
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "5px",
                    }}
                  >
                    <div className="border-b flex items-end gap-2">
                      <ReactSketchCanvas
                        canvasColor="transparent"
                        ref={canvasRef}
                        strokeWidth={2}
                        strokeColor={"black"}
                        style={{ height: "60px", border: "1px solid black" }}
                        className="cursor-pointer"
                      />
                      <IconButton color="error" onClick={handleClear}>
                        <CloseIcon />
                      </IconButton>
                    </div>
                    <span className=" text-sm text-gray-800 ">
                      Signature of Patient (or Legal representative)
                    </span>
                  </div>
                  <div className="flex justify-end">
                    <div
                      style={{
                        display:
                          "display: flex; flex-direction: column; gap: 5px",
                      }}
                    >
                      <div className="border-b border-gray-600">
                        <CustomFormField
                          control={control}
                          name="date1"
                          element="datepicker"
                          fieldProps={{}}
                          calenderProps={{ defaultValue: dayjs()}}
                          rules={{ required: false }}
                        />
                      </div>
                      <span>Date</span>
                    </div>
                  </div>
                </div>
                <p className={desc2}>
                  If under 18 years, signature of Parent or Guardian
                </p>
                <div className="signatureSection">
                  <div
                    style={{
                      display: "display: flex; flex-direction: row; gap: 5px",
                    }}
                  >
                    <span className={desc2}>Legal representative Name *</span>
                    <div className="field"></div>
                  </div>
                </div>
                <div className="signatureSection" style={{ marginTop: "16px" }}>
                  <div
                    style={{
                      display: "display: flex; flex-direction: row; gap: 5px",
                    }}
                  >
                    <span className={desc2}>Relationship with Patient *</span>
                    <div className="field"></div>
                  </div>
                </div>
                <div className="signatureSection" style={{ marginTop: "16px" }}>
                  <div
                    style={{
                      display: "display: flex; flex-direction: row; gap: 5px",
                    }}
                  >
                    <span className={desc2}>Phone Number *</span>
                    <div className="field"></div>
                  </div>
                </div>
                <div className="flex gap-5 mt-8 mx-7">
                  {/* <!-- <div className="box"></div> --> */}
                  <CustomFormField
                    control={control}
                    name="consentCheck"
                    element="checkbox"
                    fieldProps={{variant:"standard"}}
                    rules={{ required: false }}
                  />
                  <span className="pt-2 py-1 text-sm text-gray-800">
                    I consent to share my clinical records only with break the
                    glass in case of Emergency situations.
                  </span>
                </div>
                <div
                  className="flex justify-between items-end"
                  style={{ marginTop: "25px" }}
                >
                  <div
                    className="ps-8 w-[35vw]"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "5px",
                    }}
                  >
                    <div className="border-b flex items-end gap-2 ">
                      {/* <ReactSketchCanvas
                        canvasColor="transparent"
                        ref={canvasRef2}
                        strokeWidth={2}
                        strokeColor={"black"}
                        style={{ height: "35px", border: "1px solid black" }}
                        className="cursor-pointer"
                      />
                      <IconButton color="error" onClick={handleClear2}>
                        <CloseIcon />
                      </IconButton> */}
                    </div>
                    <span className={``}>
                      Signature of Patient (or Legal representative)
                    </span>
                  </div>

                  <div className="flex justify-start flex-col mx-7">
                    <div className="border-b border-black">
                      <CustomFormField
                        control={control}
                        name="date2"
                        element="datepicker"
                        fieldProps={{}}
                        calenderProps={{ defaultValue: dayjs() }}
                        rules={{ required: false }}
                      />
                    </div>
                    <span className={"desc2"}> Date </span>
                  </div>
                </div>
                <p className={desc2}>
                  (Please fill out this form and return to healthcare provider.)
                </p>
                <div className="grid grid-cols-3" style={{ marginTop: "15px" }}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      gap: "5px",
                    }}
                  >
                    <span className={desc2}>Contact Us Tel:</span>
                    <div>
                      {" "}
                      <CustomFormField
                        control={control}
                        name="contactUs"
                        element="input"
                        fieldProps={{ label: "Phone no", type: "tel",variant:"standard" }}
                        rules={{ required: false }}
                      />
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      gap: "5px",
                    }}
                  >
                    <span className={desc2}> Email: </span>
                    <div>
                      <CustomFormField
                        control={control}
                        name="email"
                        element="input"
                        fieldProps={{ label: "Email", type: "email",variant:"standard" }}
                        rules={{ required: false }}
                      />
                    </div>
                  </div>
                </div>
              </section>
              <div className="px-2">
                <Divider className="bg-[#a86c34] " />
              </div>
              <footer className="py-2 px-2">
                MoHAP | Riayati Patient Consent Form |
              </footer>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default PatientConsentForm;

const getPdfString = (patientData: PatientDetailsType, extraData: ExtraDataType) => {
  const { pmaster, amaster } = patientData;
  console.log(pmaster)
  const content = `<!DOCTYPE html>
    <html lang="en">
      <head>
        <meta charset="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <style>
        body {
          padding: 0px;
          margin: 0px;
          box-sizing: border-box;
          font-family: sans-serif;
        }
        h3 {
          margin: 0px;
          padding: 4px;
        }
        .imageLogo {
          height: 50px;
          width: 140px;
        }
        header {
          width: 100%;
          position: sticky;
          top: 0px;
          padding: 5px 6rem;
          margin: 0px;
          border-bottom: 2px solid #a86c34;
        }
        
        #logoContainer {
          height: fit-content;
        }
        
        .title {
          display: flex;
          justify-content: center;
          margin: 0px;
          border-bottom: 1px solid #a86c34;
          padding: 8px 5px;
        }
        .section1 {
          margin: 0px 1.5rem 0px 1.5rem;
        }
        .top-desc {
          margin-bottom: 5px;
          padding: 0px 5px 7px 5px;
          text-align: justify;
          font-weight: 700;
          border-bottom: 1px solid #a86c34;
        }
        .desc {
          margin: 6px 0px 5px 0px;
        }
        .divider {
          height: 1px;
          width: 100%;
          margin: 0px 0px;
          background-color: #a86c34;
        }
        .table-container{
            width: fit-content;
            height: 260px;
          }
        .details {
          width: 100%;
          height:fit-content;
          border: 1px solid #a86c34;
          border-collapse: collapse;
        }
      
        .column {
          border-top: 1px solid #a86c34;
          border-bottom: 1px solid #a86c34;
          padding: 5px;
        }
        
        .columnContent1 {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(50px, 1fr));
        }
        
        .detailsField {
          display: flex;
          flex-wrap: wrap;
          flex-direction: row;
        }
        .details td {
          border-bottom: 1px solid #a86c34;
          border-top: 1px solid #a86c34;
          padding: 5px;
        }
        .field {
          border-bottom: 1px solid black;
          text-transform: uppercase;
          text-align: justify;
          min-width: 150px;
          white-space: wrap;
          padding: 5px;
        }
        .signatureSection {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
        }
        .smallFont {
          font-size: 0.85rem;
        }
        .box {
          margin-right: 15px;
          width: 16px;
          height: 16px;
          border: 2px solid black;
        }
        footer{
          position:sticky;
          width:100%;
          bottom:0px;
          margin-top:10px ;
          padding-top: 5px;
          border-top: 2px solid #a86c34;
      }
        </style>
        <title>Consent form</title>
      </head>
      <body>
      <header>
    <div id="logoContainer">
    </div>
  </header>
  <section class="section1">
    <div class="title">
      <h3 style="color: white; background-color: #a86c34; width: fit-content">
        Patient Acknowledgement Form
      </h3>
    </div>
    <p class="top-desc">
      Use this form to receive acknowledgement from the Patient for use of
      their Electronic Healthcare Records with Participating Healthcare
      Organization and Providers in the RIAYATI HIE.
    </p>
    <p class="desc">
      <strong>National Unified Medical Record (NUMR) - RIAYATI</strong> is the
      Health Information Exchange platform of the Ministry of Health and
      Prevention (MOHAP), UAE. RIAYATI is MOHAP’s centralised repository that
      enables access to your health information to all the healthcare
      facilities (such as a hospital, nursing home, polyclinic, clinic,
      daycare centre, diagnostic centre, etc.) in the UAE that are connected
      to RIAYATI.
    </p>
    <p class="desc" style="margin-top:12px;">
      While providing access to your health information to a healthcare
      facility, RIAYATI ensures that security and privacy standards are
      followed as stipulated in the ICT Law of UAE (“the use of information
      and communication technology in the healthcare fields” law 2/2019).
    </p>
    <div style="padding-top: 8px">
      <strong>Benefits</strong>
    </div>
    <p class="desc">
      This eliminates need for redundant services, enhances patient safety,
      provides better access to health services and seamless movement between
      facilities. It helps the healthcare facilities to provide you more
      efficient care, help clinicians in accessing clinical records in
      Emergency situations.
    </p>
    <p class="desc" style="margin-top:12px;">
      Please be informed that your health information would be stored in the
      National Unified Medical Record – RIAYATI and it will be accessible by
      the healthcare facilities within UAE.
    </p>
    <div class="divider"></div>
    <p class="desc" style="font-weight: bold; font-size: 0.9rem">
      To be completed by the patient:
    </p>
    <p class="desc" style="font-weight: bold; font-size: 0.9rem;margin-top:10px;">
      PLEASE COMPLETE THE INFORMATION BELOW AND SIGN THIS FORM TO ACKNOWLEDGE
      THAT YOU HAVE READ AND UNDERSTOOD THE INFORMATION PROVIDED HERE.
    </p>
    <p class="desc" style="margin-top:10px;">
      I understand that my Health Information will be shared with
      participating healthcare organizations in the RIAYATI.
    </p>
    <p style="text-align: right;font-size: .8rem;">
      (Please complete this in BLOCK letters)
    </p>
    <div class="table-container">
   <table class="details" >
       <tr>
          <td>Patient’s Name:</td> <!-- 1 -->
          <td>Last*:</td> <!-- 2 -->
          <td><div class="field smallFont">${pmaster?.lastName || ""}</div></td> <!-- 3 -->
          <td>First*:</td>  <!-- 4 -->
          <td><div class="field smallFont">${pmaster?.firstName || ""}</div></td>  <!-- 5 -->
          <td>Middle:</td> <!-- 6 -->
          <td><div class="field">${pmaster?.middleName || ""}</div></td>  <!-- 7 -->
       </tr>
       <tr>
          <td>National ID Number*:</td>
          <td colspan="2"><div class="field smallFont">${pmaster?.emiratesId || ""}</div></td>
          <td>Patient’s DOB*:</td>
          <td><div class="field smallFont">${pmaster?.dob || ""}</div></td>
          <td>Sex (M/F)</td>
          <td ><div class="field smallFont">${pmaster?.gender || ""}</div></td>
       </tr>
       <tr>
          <td>Primary Phone#*:</td>
          <td colspan="2"><div class="field smallFont">${amaster?.mobileNo || ""}</div></td>
          <td>Secondary Phone#:</td>
          <td><div class="field smallFont">${amaster?.mobileNo || ""}</div></td>
          <td>Email</td>
          <td ><div class="field">${amaster?.email || ""}</div></td>
       </tr>
       <tr>
          <td>Postal Address*:</td>
          <td colspan="6"><div class="field smallFont">${amaster?.address1 || ""}</div></td>
       </tr>
       <tr>
          <td>City*:</td>
          <td colspan="3"><div class="field smallFont">${amaster?.place || ""}</div></td>
          <td>PO Box*:</td>
          <td colspan="2"><div class="field smallFont">${""}</div></td>
       </tr>
    </table> 
    </div>

    <div class="signatureSection">
      <div style="display: flex; flex-direction: column; gap: 5px">
        <div class="field">
          <div id="signContainer" style="width: 400px; height: 50px;"> </div>
        </div>
        <span> Signature of Patient (or Legal representative) </span>
      </div>
      <div>
          <p style="text-align: end; font-size: smaller;">
              *mandatory information
            </p>
        <div style="display: flex; flex-direction: column; gap: 5px">
          <div class="field">${extraData.date1 ? moment(extraData.date1).format("DD-MM-YYYY") : moment().format("DD-MM-YYYY")}</div>
          <span> Date </span>
        </div>
      </div>
    </div>

    <p style="text-align: start; font-size: normal;">
      If under 18 years, signature of Parent or Guardian
    </p>
    <div class="signatureSection">
      <div style="display: flex;flex-direction: row; gap: 5px;">
          <span>
              Legal representative Name*
          </span>
          <div class="field"></div>
       </div>
    </div>
    <div class="signatureSection" style="margin-top:16px;">
      <div style="display: flex;flex-direction: row; gap: 5px;">
          <span>
              Relationship with Patient*
          </span>
          <div class="field"></div>
       </div>
    </div>
    <div class="signatureSection" style="margin-top:16px;">
      <div style="display: flex;flex-direction: row; gap: 5px;">
          <span>
              Phone Number*
          </span>
          <div class="field"></div>
       </div>
    </div>
    <div style="margin-top: 8px;display: flex;gap:5px;">
      ${extraData?.consentCheck ? '<input type="checkbox" checked />' : '<input type="checkbox"/>'} <span>I consent to share my clinical records only with break the glass in case of Emergency situations.</span>
    </div>
    <div class="signatureSection" style="margin-top: 25px;">
      <div style="display: flex;flex-direction: column; gap: 5px;">
         <div class="field" id="signContainer2"></div>
         <span>
             Signature of Patient (or Legal representative)
         </span>
      </div>
      <div style="display: flex;flex-direction: column; gap: 5px;">
         <div style="border-bottom: 1px solid black;width:15vw;">${extraData.date2 ? moment(extraData.date2).format("DD-MM-YYYY") : ""}</div>
         <span>
             Date
         </span>
      </div>
   </div>
   <p>(Please fill out this form and return to healthcare provider.)</p>
    <div class="signatureSection" style="margin-top: 15px;">
      <div style="display: flex;flex-direction: row; gap: 5px;">
         <span>
          Contact Us Tel:
         </span>
         <div >${extraData?.contactUs || ""}</div>
      </div>
      <div style="display: flex;flex-direction: row; gap: 5px;">
         <span>
          Email:
         </span>
         <div style="width:40vw;">${extraData?.email || ""}</div>
      </div>
   </div>
  </section>
  <footer>
  MoHAP | Riayati Patient Consent Form |
</footer>
      </body>
    </html>
    `;
  return content;
};

